import { WindScenario } from "../services/api";

/** Measurement heights supported by the wind backend endpoints */
export const WIND_HEIGHTS = ["50m", "100m", "150m", "200m"] as const;

export type WindHeight = typeof WIND_HEIGHTS[number];

/** Display labels for each viability scenario */
export const WIND_SCENARIOS: { value: WindScenario; label: string }[] = [
  { value: WindScenario.Teorico,    label: "Teórico" },
  { value: WindScenario.Geografico, label: "Geográfico" },
  { value: WindScenario.Economico,  label: "Econômico" },
];
